// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarVideo_main__Wqlcq","intro":"ModalEditarVideo_intro__Y3CaP","input":"ModalEditarVideo_input__o+Klx"};